// src/components/PaymentSuccessPopup.jsx
const SuccessPopup = ({ onClose }: any) => {
  const completedSteps = [
    "KYC Verification",
    "E-Signatures", 
    "Payment Setup"
  ];

  return (
    <div className="fixed inset-0 flex items-center justify-center min-h-screen bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-4 text-center relative">
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200"
        >
          <svg 
            className="w-6 h-6" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M6 18L18 6M6 6l12 12" 
            />
          </svg>
        </button>

        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
          <svg 
            fill="none" 
            stroke="white" 
            viewBox="0 0 24 24" 
            className="w-10 h-10 stroke-[3]"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              d="M5 13l4 4L19 7" 
            />
          </svg>
        </div>

        {/* Main Title */}
        <h1 className="text-gray-800 text-2xl font-bold mb-4">
          🎉 Onboarding Completed!
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 mb-6">
          Congratulations! You've successfully completed all verification steps.
        </p>

        {/* Completed Steps */}
        <div className="space-y-3 mb-6">
          {completedSteps.map((step, index) => (
            <div key={index} className="flex items-center justify-center space-x-3">
              <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <svg 
                  className="w-4 h-4 text-white" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={3} 
                    d="M5 13l4 4L19 7" 
                  />
                </svg>
              </div>
              <span className="text-gray-700 font-medium">{step}</span>
            </div>
          ))}
        </div>

        {/* Success Message */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <div className="text-green-700 font-semibold">
            ✓ All verification steps completed successfully
          </div>
         
        </div>

       
      </div>
    </div>
  );
};

export default SuccessPopup;